export default {
  RESET_STATE: "RESET_STATE",

  SET_PDF_FILE: "SET_PDF_FILE",
  SET_IS_CUSTOM_FILE: "SET_IS_CUSTOM_FILE",
  SET_PDF_URL: "SET_PDF_URL",
  SET_PDF_PAGE: "SET_PDF_PAGE",
  SET_PDF_TOTAL_PAGE: "SET_PDF_TOTAL_PAGE",
  SET_PDF_SCALE: "SET_PDF_SCALE",
  RESET_PDF_FILE_AND_URL: "RESET_PDF_FILE_AND_URL",
  REQUEST_CONVERT_TO_PDF: "REQUEST_CONVERT_TO_PDF",
  RECEIVE_CONVERT_TO_PDF: "RECEIVE_CONVERT_TO_PDF",
  REQUEST_UPLOAD_FILE_FROM_URL: "REQUEST_UPLOAD_FILE_FROM_URL",
  RECEIVE_UPLOAD_FILE_FROM_URL: "RECEIVE_UPLOAD_FILE_FROM_URL",
  REQUEST_RUN_TEMPLATE: "REQUEST_RUN_TEMPLATE",
  RECEIVE_RUN_TEMPLATE: "RECEIVE_RUN_TEMPLATE",
  REQUEST_DETECT_MACRO: "REQUEST_DETECT_MACRO",
  RECEIVE_DETECT_MACRO: "RECEIVE_DETECT_MACRO",
  REQUEST_DETECT_FIELDS: "REQUEST_DETECT_FIELDS",
  RECEIVE_DETECT_FIELDS: "RECEIVE_DETECT_FIELDS",
  REQUEST_DETECT_GRID_STRUCTURE: "REQUEST_DETECT_GRID_STRUCTURE",
  RECEIVE_DETECT_GRID_STRUCTURE: "RECEIVE_DETECT_GRID_STRUCTURE",
  SET_PDF_FILE_NAME: "SET_PDF_FILE_NAME",
  SET_TEMPLATE_FILE_NAME: "SET_TEMPLATE_FILE_NAME",
  SET_API_ERROR: "SET_API_ERROR",
  SET_REMAINING_CREDITS: "SET_REMAINING_CREDITS",

  SAVE_TEMPLATE: "SAVE_TEMPLATE",
  SET_TEMPLATE: "SET_TEMPLATE",
  SET_TEMPLATE_ID: "SET_TEMPLATE_ID",
  RESET_TEMPLATE: "RESET_TEMPLATE",
  DELETE_TEMPLATE_OBJECT: "DELETE_TEMPLATE_OBJECT",
  ADD_TEMPLATE_OBJECT: "ADD_TEMPLATE_OBJECT",
  SET_ACTIVE_OBJECT: "SET_ACTIVE_OBJECT",
  CHANGE_OBJECT_NAME: "CHANGE_OBJECT_NAME",
  CHANGE_RECTANGLE_FIELD_COORDINATES: "CHANGE_RECTANGLE_FIELD_COORDINATES",
  CHANGE_RECTANGLE_FIELD_SIZES: "CHANGE_RECTANGLE_FIELD_SIZES",
  CHANGE_RECTANGLE_TABLE_COORDINATES: "CHANGE_RECTANGLE_TABLE_COORDINATES",
  CHANGE_RECTANGLE_TABLE_SIZES: "CHANGE_RECTANGLE_TABLE_SIZES",
  CHANGE_OBJECT_DATA_TYPE: "CHANGE_OBJECT_DATA_TYPE",
  CHANGE_OBJECT_PAGE_INDEX: "CHANGE_OBJECT_PAGE_INDEX",
  CHANGE_OBJECT_EXPRESSION: "CHANGE_OBJECT_EXPRESSION",
  CHANGE_OBJECT_DATE_FORMAT: "CHANGE_OBJECT_DATE_FORMAT",
  CHANGE_OBJECT_COALESCING_WITH: "CHANGE_OBJECT_COALESCING_WITH",
  CHANGE_TABLE_ROW_MERGING_RULE: "CHANGE_TABLE_ROW_MERGING_RULE",
  CHANGE_SEARCH_BASED_TABLE_PROPERTIES: "CHANGE_SEARCH_BASED_TABLE_PROPERTIES",
  CHANGE_GRID_CELL_FIELD_COLUMN: "CHANGE_GRID_CELL_FIELD_COLUMN",
  CHANGE_GRID_CELL_FIELD_ROW: "CHANGE_GRID_CELL_FIELD_ROW",
  INSERT_MACROS_INTO_OBJECT: "INSERT_MACROS_INTO_OBJECT",
  SET_REGEX_STATUS_TO_OBJECT: "SET_REGEX_STATUS_TO_OBJECT",
  UNDO_OBJECTS_CHANGES: "UNDO_OBJECTS_CHANGES",

  SET_TEST_FIELD_RESULT_ID: "SET_TEST_FIELD_RESULT_ID",

  SET_IS_TEMPLATE_MODIFIED: "SET_IS_TEMPLATE_MODIFIED",

  CHANGE_TEMPLATE_NAME: "CHANGE_TEMPLATE_NAME",
  CHANGE_TEMPLATE_DESCRIPTION: "CHANGE_TEMPLATE_DESCRIPTION",
  CHANGE_TEMPLATE_TIMESTAMP: "CHANGE_TEMPLATE_TIMESTAMP",
  CHANGE_TEMPLATE_PRIORITY: "CHANGE_TEMPLATE_PRIORITY",
  CHANGE_TEMPLATE_CULTURE: "CHANGE_TEMPLATE_CULTURE",
  CHANGE_TEMPLATE_OCR_MODE: "CHANGE_TEMPLATE_OCR_MODE",
  CHANGE_TEMPLATE_OCR_LANGUAGE: "CHANGE_TEMPLATE_OCR_LANGUAGE",
  CHANGE_TEMPLATE_OCR_RESOLUTION: "CHANGE_TEMPLATE_OCR_RESOLUTION",
  CHANGE_TEMPLATE_OCR_IMAGE_FILTERS: "CHANGE_TEMPLATE_OCR_IMAGE_FILTERS",
  CHANGE_TEMPLATE_OCR_WHITE_LIST: "CHANGE_TEMPLATE_OCR_WHITE_LIST",
  CHANGE_TEMPLATE_OCR_BLACK_LIST: "CHANGE_TEMPLATE_OCR_BLACK_LIST",
   

  SET_CANVAS_MARGIN_LEFT: "SET_CANVAS_MARGIN_LEFT",
  SET_CANVAS_DIMENSIONS: "SET_CANVAS_DIMENSIONS",
  SET_CANVAS_CURRENT_PAGE_ORIGINAL_DIMENSIONS: "SET_CANVAS_CURRENT_PAGE_ORIGINAL_DIMENSIONS",

  SORT_TEMPLATE_OBJECTS: "SORT_TEMPLATE_OBJECTS",

  OPEN_TEMPLATE_SETTINGS_MODAL: "OPEN_TEMPLATE_SETTINGS_MODAL",
  OPEN_EDIT_TEMPLATE_MODAL: "OPEN_EDIT_TEMPLATE_MODAL",
  OPEN_MACROS_MODAL: "OPEN_MACROS_MODAL",
  OPEN_RUN_TEMPLATE_RESULT_MODAL: "OPEN_RUN_TEMPLATE_RESULT_MODAL",
  OPEN_RUN_TEMPLATE_WITH_ONE_OBJECT_RESULT_MODAL: "OPEN_RUN_TEMPLATE_WITH_ONE_OBJECT_RESULT_MODAL",
  OPEN_SELECT_GRID_CELL_MODAL: "OPEN_SELECT_GRID_CELL_MODAL",
  CLOSE_ALL_MODALS: "CLOSE_ALL_MODALS",

  OPEN_RUN_TEMPLATE_RESULT_WINDOW: "OPEN_RUN_TEMPLATE_RESULT_WINDOW",
  OPEN_RUN_OBJECT_RESULT_WINDOW: "OPEN_RUN_OBJECT_RESULT_WINDOW",
  CLOSE_ALL_WINDOWS: "CLOSE_ALL_WINDOWS",

  MARK_FAIL_TO_FILE_UPLOADED: "MARK_FAIL_TO_FILE_UPLOADED",
  MARK_SUCCESS_TO_FILE_UPLOADED: "MARK_SUCCESS_TO_FILE_UPLOADED",

}
